module.exports = __webpack_public_path__ + "static/media/change.80ccb03e.svg";